/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum APIPaths {
  RESERVATION_CALENDAR_AVAILABILITY_STATISTICS_RANGES = '/reservation-calendar/availability-statistics/ranges',
  RESERVATION_CALENDAR_CALENDAR_DETAIL = '/reservation-calendar/calendar/:calendarId',
  RESERVATION_CALENDAR_CALENDAR_CREATE = '/reservation-calendar/calendar',
  RESERVATION_CALENDAR_CALENDAR_UPDATE = '/reservation-calendar/calendar/:calendarId',
  RESERVATION_CALENDAR_CALENDAR_DELETE = '/reservation-calendar/calendar/:calendarId',
  RESERVATION_CALENDAR_USER_SETTING_SAVE_SIZES = '/reservation-calendar/user-setting/save-sizes',
  RESERVATION_CALENDAR_CALENDAR_OBJECT_ROOMS = '/reservation-calendar/calendar/:calendarId/object-rooms',
  RESERVATION_CALENDAR_CALENDAR_RESERVATIONS = '/reservation-calendar/calendar/:calendarId/reservations',
  RESERVATION_CALENDAR_CALENDAR_CLOSED_TERMS = '/reservation-calendar/calendar/:calendarId/closed-terms',
  RESERVATION_CALENDAR_CALENDAR_SIGNIFICANT_DATES = '/reservation-calendar/calendar/:calendarId/significant-dates',
  RESERVATION_CALENDAR_CALENDAR_HINT = '/reservation-calendar/calendar/:reservationId/hint',
  RESERVATION_CALENDAR_CALENDAR_RESERVATION_OVERVIEW = '/reservation-calendar/calendar/:reservationId/reservation-overview',
  RESERVATION_CALENDAR_CALENDAR_COPY_RESERVATION = '/reservation-calendar/calendar/:reservationRoomId/copy-reservation',
  RESERVATION_CALENDAR_CALENDAR_MOVE_SPLIT_RESERVATION = '/reservation-calendar/calendar/:reservationRoomId/move-split-reservation',
  RESERVATION_CALENDAR_CALENDAR_PRINT = '/reservation-calendar/calendar/print',
  RESERVATION_CALENDAR_CALENDARS_LIST = '/reservation-calendar/calendars',
  RESERVATION_CALENDAR_CALENDARS_REORDER = '/reservation-calendar/calendars/reorder',
  RESERVATION_CALENDAR_CALENDARS_ICONS = '/reservation-calendar/calendars/icons',
  RESERVATION_CALENDAR_CALENDARS_RESERVATIONS_SUGGESTION = '/reservation-calendar/calendars/reservations-suggestion',
  RESERVATION_CALENDAR_CLOSED_TERM_TOGGLE = '/reservation-calendar/closed-term/:calendarId',
  RESERVATION_CALENDAR_RESERVATION_ROOM_ASSIGNMENT_CHANGE_TERM = '/reservation-calendar/reservation-room/:reservationRoomId/assignment/term',
  RESERVATION_CALENDAR_RESERVATION_ROOM_ASSIGNMENT_CANCEL = '/reservation-calendar/reservation-room/:reservationRoomId/assignment/cancel',
  RESERVATION_CALENDAR_RESERVATION_ROOM_ASSIGNMENT_NO_SHOW = '/reservation-calendar/reservation-room/:reservationRoomId/assignment/no-show',
  RESERVATION_CALENDAR_RESERVATION_ROOM_ASSIGNMENT_CHECK_IN = '/reservation-calendar/reservation-room/:reservationRoomId/assignment/check-in',
  RESERVATION_CALENDAR_RESERVATION_ROOM_ASSIGNMENT_CHECK_OUT = '/reservation-calendar/reservation-room/:reservationRoomId/assignment/check-out',
  RESERVATION_CALENDAR_RESERVATION_ROOM_PIN = '/reservation-calendar/reservation-room/:reservationRoomId/pin',
  RESERVATION_CALENDAR_RESERVATION_ROOM_UNPIN = '/reservation-calendar/reservation-room/:reservationRoomId/unpin',
  RESERVATION_CALENDAR_RESERVATION_REMOVE_ROOM_FROM_GROUP = '/reservation-calendar/reservation-room/:reservationRoomId/remove-from-group',
  RESERVATION_CALENDAR_RESERVATION_ASSIGNMENT_CANCEL = '/reservation-calendar/reservation/:reservationId/assignment/cancel',
  RESERVATION_CALENDAR_RESERVATION_ASSIGNMENT_NO_SHOW = '/reservation-calendar/reservation/:reservationId/assignment/no-show',
  RESERVATION_CALENDAR_RESERVATION_ASSIGNMENT_CHECK_IN = '/reservation-calendar/reservation/:reservationId/assignment/check-in',
  RESERVATION_CALENDAR_RESERVATION_ASSIGNMENT_CHECK_OUT = '/reservation-calendar/reservation/:reservationId/assignment/check-out',
  RESERVATION_CALENDAR_OVERVIEW = '/reservation-calendar/overview',
  RESERVATION_CALENDAR_RESERVATIONS_OPTIMIZER_SUGGEST = '/reservation-calendar/reservations-optimizer/suggest',
  RESERVATION_CALENDAR_RESERVATIONS_OPTIMIZER_SAVE = '/reservation-calendar/reservations-optimizer/save',
  RESERVATION_CALENDAR_FLOATING_RESERVATIONS = '/reservation-calendar/floating-calendar/reservations',

  REPORTS_DAILY_OVERVIEW_PRESETS = '/reports/daily-overview/presets',
  REPORTS_DAILY_OVERVIEW_PRINT = '/reports/daily-overview/print',

  REPORTS_NTAK_LIST = '/reports/ntak',
  REPORTS_NTAK_ACCOUNTS = '/reports/ntak/accounts',
  REPORTS_NTAK_DETAIL = '/reports/ntak/:id',
  REPORTS_NTAK_DAILY_CLOSURE_CORRECT = '/reports/ntak/daily-closure/:id/correct',

  AVAILABILITY_AVAILABLE_OBJECT_ROOMS = '/availability/available-object-rooms',
  AVAILABILITY_AVAILABLE_OBJECT_ROOMS_MARKERS = '/availability/available-object-rooms-markers',
  AVAILABILITY_AVAILABLE_OBJECT_ROOMS_SLOTS = '/availability/available-object-rooms-slots',

  RESERVATION_DETAIL = '/reservation/detail/:reservationId/detail',
  RESERVATION_DETAIL_ROOMS = '/reservation/detail/:reservationId/rooms',
  RESERVATION_DETAIL_VENUES = '/reservation/detail/:reservationId/venues',
  RESERVATION_DETAIL_CHECKIN_COMPLETENESS = '/reservation/detail/:reservationId/checkin-completeness',
  RESERVATION_DETAIL_TASKS = '/reservation/detail/tasks',
  RESERVATION_DETAIL_NUM_OF_TASKS = '/reservation/detail/numOfTasks',
  RESERVATION_DETAIL_OVERVIEW = '/reservation/detail/:reservationId/overview',
  RESERVATION_DETAIL_ATTACHMENTS = '/reservation/detail/:reservationId/attachments',
  RESERVATION_DETAIL_ATTACHMENT_URL = '/reservation/detail/:reservationId/attachment/:attachmentId/url',
  RESERVATION_DETAIL_ATTACHMENT_CREATE = '/reservation/detail/:reservationId/attachment',
  RESERVATION_DETAIL_ATTACHMENT_DELETE = '/reservation/detail/:reservationId/attachment/:attachmentId',
  RESERVATION_DETAIL_COMMUNICATION = '/reservation/detail/:reservationId/communications',
  RESERVATION_DETAIL_COMMUNICATION_CREATE_THREAD = '/reservation/detail/:reservationId/communication/threads',
  RESERVATION_DETAIL_COMMUNICATION_SEND_MESSAGE = '/reservation/detail/:reservationId/communication/message',
  RESERVATION_DETAIL_COMMUNICATION_SUGGEST_REPLY = '/reservation/detail/:reservationId/communication/suggest-reply',
  RESERVATION_DETAIL_COMMUNICATION_REPEAT_MESSAGE = '/reservation/detail/:reservationId/communication/threads/:threadId/messages/:messageId/repeat',
  RESERVATION_DETAIL_COMMUNICATION_UPLOAD_ATTACHMENT = '/reservation/detail/communication/threads/:threadId/attachment',
  RESERVATION_DETAIL_COMMUNICATION_DELETE_ATTACHMENT = '/reservation/detail/communication/threads/:threadId/attachment/:remoteFileId',
  RESERVATION_DETAIL_HISTORY = '/reservation/detail/:reservationId/history',
  RESERVATION_DETAIL_HISTORY_CONTACT_PERSON = '/reservation/detail/:reservationId/history/contact-person/:index/:entryId',
  RESERVATION_DETAIL_HISTORY_NOTE = '/reservation/detail/:reservationId/history/note/:index/:entryId',
  RESERVATION_DETAIL_HISTORY_RESERVATION = '/reservation/detail/:reservationId/history/reservation/:index/:entryId',
  RESERVATION_DETAIL_HISTORY_RESERVATION_ROOM = '/reservation/detail/:reservationId/history/reservation-room/:index/:entryId',

  RESERVATION_GUEST_LIST_EXPORT = '/reservation/guest-list/:reservationId/export',

  RESERVATION_RESERVATION_CREATE = '/reservation/reservation',
  RESERVATION_RESERVATION_ADD_ROOMS = '/reservation/reservation/:reservationId/add-rooms',
  RESERVATION_RESERVATION_ADD_ROOMS_FORM_LOAD = '/reservation/reservation/:reservationId/add-rooms-form',
  RESERVATION_VENUE_CREATE = '/reservation/venue',
  RESERVATION_VENUE_UNSCHEDULED_DELETE = '/reservation/venue/:reservationId/unscheduled',
  RESERVATION_VENUE_UNSCHEDULED_SCHEDULE = '/reservation/venue/:reservationId/unscheduled/schedule',
  RESERVATION_VENUE_SCHEDULED_EDIT = '/reservation/venue/:reservationId/scheduled',
  RESERVATION_RESERVATION_DELETE = '/reservation/reservation/:reservationId',
  RESERVATION_RESERVATION_LOCK = '/reservation/reservation/:reservationId/lock',
  RESERVATION_RESERVATION_UNLOCK = '/reservation/reservation/:reservationId/unlock',
  RESERVATION_RESERVATION_CHANGE_SOURCE = '/reservation/reservation/:reservationId/source',
  RESERVATION_RESERVATION_CHANGE_PAYMENT_STATUS = '/reservation/reservation/:reservationId/payment-status',
  RESERVATION_RESERVATION_CHANGE_RATE_PLAN = '/reservation/reservation/:reservationId/rate-plan',
  RESERVATION_RESERVATION_CHANGE_STAY_PACKAGE = '/reservation/reservation/:reservationId/stay-package',
  RESERVATION_RESERVATION_CHANGE_CODE = '/reservation/reservation/:reservationId/code',
  RESERVATION_RESERVATION_SEND_EMAIL_CHECKIN = '/reservation/reservation/:reservationId/send-email-checkin',
  RESERVATION_RESERVATION_OCCUPIED_OBJECT_ROOMS = '/reservation/reservation/occupied-object-rooms',
  RESERVATION_RESERVATION_NOTES = '/reservation/reservation/:reservationId/notes',
  RESERVATION_RESERVATION_ADD_NOTE = '/reservation/reservation/:reservationId/note',
  RESERVATION_RESERVATION_UPDATE_NOTE = '/reservation/reservation/:reservationId/note/:noteId',
  RESERVATION_RESERVATION_DELETE_NOTE = '/reservation/reservation/:reservationId/note/:noteId',
  RESERVATION_RESERVATION_CHANGE_MARKET_SEGMENT = '/reservation/reservation/:reservationId/market-segment',

  RESERVATION_RESERVATION_MERGE = '/reservation/reservation/:reservationId/merge-reservation',
  RESERVATION_RESERVATION_MERGE_SUGGESTION = '/reservation/reservation/:reservationId/merge-suggestion',
  RESERVATION_RESERVATION_MERGE_OVERVIEW = '/reservation/reservation/:reservationId/merge-overview',

  RESERVATION_RESERVATION_DELETE_DIALOG = '/reservation/delete-dialog/:reservationId',

  RESERVATION_RESERVATION_ASSIGNMENT_CHANGE_STATUS = '/reservation/reservation/:reservationId/assignment/status',
  RESERVATION_RESERVATION_ASSIGNMENT_CHANGE_TERM = '/reservation/reservation/:reservationId/assignment/term',
  RESERVATION_CALENDAR_RESERVATION_ROOMS_ASSIGNMENT_CHANGE_TERM = '/reservation-calendar/reservation-rooms/:reservationId/assignment/term',
  RESERVATION_CALENDAR_RESERVATION_ROOMS_ASSIGNMENT_CHANGE_OBJECT = '/reservation-calendar/reservation-rooms/:reservationId/assignment/object',
  RESERVATION_CALENDAR_RESERVATION_ROOMS_ASSIGNMENT_SWAP = '/reservation-calendar/reservation-rooms/assignment/swap',

  RESERVATION_COMPANY_CHANGE_PREVIEW = '/reservation/company/:reservationId/company-change-preview/:companyId',
  RESERVATION_COMPANY_CHANGE = '/reservation/company/:reservationId',
  RESERVATION_COMPANY_REMOVE = '/reservation/company/:reservationId',
  RESERVATION_COMPANY_DETAIL = '/reservation/company/:companyId/detail',

  RESERVATION_CONTACT_PERSON_CHANGE = '/reservation/contact-person/:reservationId',
  RESERVATION_CONTACT_PERSON_REMOVE = '/reservation/contact-person/:reservationId',

  RESERVATION_CURRENCY_GET_PRICE = '/reservation/currency/:reservationId/get-price',
  RESERVATION_CURRENCY_CHANGE = '/reservation/currency/:reservationId',

  RESERVATION_GUEST_CHANGE_GUEST_CATEGORY = '/reservation/guest/:reservationRoomId/guest-category',
  RESERVATION_GUEST_CHANGE_PURPOSE_OF_STAY = '/reservation/guest/:reservationRoomId/purpose-of-stay',

  RESERVATION_MARKET_CODES_CHANGE = '/reservation/market-code/:reservationId',

  RESERVATION_RESERVATION_DELETE_ROOMS = '/reservation/reservation/:reservationId/delete-rooms',
  RESERVATION_RESERVATION_REMOVE_ROOMS = '/reservation/reservation/:reservationId/remove-rooms',

  RESERVATION_FOLIO = '/reservation/folio/:reservationId',
  RESERVATION_FOLIO_FOLIO_ITEM_DETAIL = '/reservation/folio/:reservationId/item/:folioItemId',
  RESERVATION_FOLIO_FOLIO_ITEM_OVERVIEW = '/reservation/folio/:reservationId/item/:folioItemId/overview',
  RESERVATION_FOLIO_FOLIO_ITEM_EMPTY_DETAIL = '/reservation/folio/:reservationId/item/empty-detail',
  RESERVATION_FOLIO_EXPORT = '/reservation/folio/:reservationId/export',
  RESERVATION_FOLIO_FOLIO_ITEM_OWNER_SUGGESTIONS = '/reservation/folio/:reservationId/item/owner-suggestions',
  RESERVATION_FOLIO_FOLIO_ITEM_CHANGE_OWNER = '/reservation/folio/:reservationId/item/bulk-change-owner',
  RESERVATION_FOLIO_FOLIO_ITEM_CREATE = '/reservation/folio/:reservationId/item/create',
  RESERVATION_FOLIO_FOLIO_ITEM_CREATE_BULK = '/reservation/folio/:reservationId/item/create-bulk',
  RESERVATION_FOLIO_FOLIO_ITEM_UPDATE = '/reservation/folio/:reservationId/item/:folioItemId',
  RESERVATION_FOLIO_FOLIO_ITEM_DELETE = '/reservation/folio/:reservationId/item/:folioItemId',
  RESERVATION_FOLIO_FOLIO_ITEM_BULK_DELETE = '/reservation/folio/:reservationId/item/bulk-delete',
  RESERVATION_FOLIO_FOLIO_ITEM_SUGGESTIONS = '/reservation/folio/:reservationId/item-suggestions',
  RESERVATION_FOLIO_STAY_PACKAGE_SUGGESTIONS = '/reservation/folio/:reservationId/stay-package-suggestions',
  RESERVATION_FOLIO_DISCOUNT_COUPON_SUGGESTIONS = '/reservation/folio/:reservationId/discount-coupon-suggestions',
  RESERVATION_FOLIO_SPLIT_ITEMS = '/reservation/folio/:reservationId/split-items',
  RESERVATION_FOLIO_SPLIT_SETTINGS = '/reservation/folio/:reservationId/split-settings',
  RESERVATION_FOLIO_RECALCULATE = '/reservation/folio/:reservationId/recalculate',
  RESERVATION_FOLIO_LOCK = '/reservation/folio/:reservationId/lock',
  RESERVATION_FOLIO_UNLOCK = '/reservation/folio/:reservationId/unlock',
  RESERVATION_FOLIO_PRICE_CORRECTION = '/reservation/folio/:reservationId/price-correction',
  RESERVATION_FOLIO_PRICE_CHANGE = '/reservation/folio/:reservationId/price-change',
  RESERVATION_FOLIO_PRICE_DISCOUNT_COUPON = '/reservation/folio/:reservationId/price-discount-coupon',
  RESERVATION_UNASSIGN_DOCUMENT = '/reservation/folio-document/unassign-document',
  RESERVATION_ASSIGN_DOCUMENT = '/reservation/folio-document/assign-documents',

  RESERVATION_RESERVATION_ROOM_DETAIL = '/reservation/reservation-room/:reservationRoomId',
  RESERVATION_RESERVATION_ROOM_LOCK = '/reservation/reservation-room/:reservationRoomId/lock',
  RESERVATION_RESERVATION_ROOM_UNLOCK = '/reservation/reservation-room/:reservationRoomId/unlock',
  RESERVATION_RESERVATION_ROOM_PIN = '/reservation/reservation-room/:reservationRoomId/pin',
  RESERVATION_RESERVATION_ROOM_UNPIN = '/reservation/reservation-room/:reservationRoomId/unpin',
  RESERVATION_RESERVATION_ROOM_CHANGE_PAYMENT_STATUS = '/reservation/reservation-room/:reservationRoomId/payment-status',
  RESERVATION_RESERVATION_ROOM_CHANGE_RATE_PLAN = '/reservation/reservation-room/:reservationRoomId/rate-plan',
  RESERVATION_RESERVATION_ROOM_CHANGE_STAY_PACKAGE = '/reservation/reservation-room/:reservationRoomId/stay-package',
  RESERVATION_RESERVATION_ROOM_CHANGE_CODE = '/reservation/reservation-room/:reservationRoomId/code',
  RESERVATION_RESERVATION_ROOM_CHANGE_PREVIEW = '/reservation/reservation-room/:reservationRoomId/room-change-preview',

  RESERVATION_RESERVATION_ROOM_ASSIGNMENT_CHANGE_OBJECT = '/reservation/reservation-room/:reservationRoomId/assignment/object',
  RESERVATION_RESERVATION_ROOM_ASSIGNMENT_CHANGE_STATUS = '/reservation/reservation-room/:reservationRoomId/assignment/status',
  RESERVATION_RESERVATION_ROOM_ASSIGNMENT_CHANGE_TERM = '/reservation/reservation-room/:reservationRoomId/assignment/term',

  RESERVATION_RESERVATION_ROOM_NOTES = '/reservation/reservation-room/:reservationRoomId/notes',
  RESERVATION_RESERVATION_ROOM_ADD_NOTE = '/reservation/reservation-room/:reservationRoomId/note',
  RESERVATION_RESERVATION_ROOM_UPDATE_NOTE = '/reservation/reservation-room/:reservationRoomId/note/:noteId',
  RESERVATION_RESERVATION_ROOM_DELETE_NOTE = '/reservation/reservation-room/:reservationRoomId/note/:noteId',
  RESERVATION_RESERVATION_ROOM_CHANGE_MARKET_SEGMENT = '/reservation/reservation-room/:reservationRoomId/market-segment',

  RESERVATION_RESERVATION_ROOMS_SUGGEST = '/reservation/reservation-rooms/suggest',

  RESERVATION_GRID_LIST = '/reservation-grid/grid',
  RESERVATION_GRID_EXPORT = '/reservation-grid/grid/export',

  RESERVATION_RESERVATION_GUEST_FORM = '/reservation/reservation-guest-form/:reservationRoomId',
  RESERVATION_RESERVATION_GUEST_FORM_ADD = '/reservation/reservation-guest-form/:reservationRoomId/add',
  RESERVATION_RESERVATION_GUEST_FORM_REMOVE = '/reservation/reservation-guest-form/:reservationRoomId/remove/:reservationGuestNumber',
  RESERVATION_RESERVATION_GUEST_FORM_VERIFY_GUEST_CHANGE = '/reservation/reservation-guest-form/verify-guest-change',
  RESERVATION_RESERVATION_GUEST_FORM_APPLY_CHANGES = '/reservation/reservation-guest-form/:reservationRoomId/apply-changes/:reservationGuestNumber',

  RESERVATION_RESERVATION_EDIT_ROOMS_FORM_LOAD = '/reservation/edit-rooms-form/:reservationId/load-form',
  RESERVATION_RESERVATION_EDIT_ROOMS_FORM_SUBMIT = '/reservation/edit-rooms-form/:reservationId/apply-changes',

  RESERVATION_DIALOGS_PRINT_GUEST_CARD_RESERVATIONS = '/reservation/dialogs/print-guest-card/by-reservations',
  RESERVATION_DIALOGS_PRINT_GUEST_CARD_ROOM = '/reservation/dialogs/print-guest-card/by-room/:reservationRoomId',
  RESERVATION_DIALOGS_PRINT_GUEST_CARD_CALENDAR = '/reservation/dialogs/print-guest-card/by-date/:date',
  RESERVATION_DIALOGS_PRINT_GUEST_CARD_PRINT = '/reservation/dialogs/print-guest-card/print',

  RESERVATION_DIALOGS_PRINT_SK_RESIDENCE_REPORT_RESERVATION = '/reservation/dialogs/sk-residence-report/reservation/:reservationId',
  RESERVATION_DIALOGS_PRINT_SK_RESIDENCE_REPORT_ROOM = '/reservation/dialogs/sk-residence-report/reservation-room/:reservationRoomId',
  RESERVATION_DIALOGS_PRINT_SK_RESIDENCE_REPORT_PRINT = '/reservation/dialogs/sk-residence-report/print',

  RESERVATION_RESERVATION_ROOM_GUEST_ADD = '/reservation/reservation-room/:reservationRoomId/guest',
  RESERVATION_RESERVATION_ROOM_GUEST_UPDATE = '/reservation/reservation-room/:reservationRoomId/guest/:reservationGuestNumber',
  RESERVATION_RESERVATION_ROOM_GUEST_REMOVE = '/reservation/reservation-room/:reservationRoomId/guest/:reservationGuestNumber',

  RESERVATION_CREDIT_CARD_DETAIL = '/reservation/credit-card/:reservationId',
  RESERVATION_CREDIT_CARD_REPORT = '/reservation/credit-card/:reservationId/report-card',
  RESERVATION_CREDIT_CARD_CANCEL_RESERVATION = '/reservation/credit-card/:reservationId/cancel-reservation',

  RESERVATION_VOUCHER_SETTINGS = '/reservation/voucher/:reservationId/settings',
  RESERVATION_VOUCHER_TEMPLATES = '/reservation/voucher/:reservationId/templates/:languageId',
  RESERVATION_VOUCHER_PREVIEW = '/reservation/voucher/:reservationId/preview',
  RESERVATION_VOUCHER_RECIPIENT_SUGGESTION = '/reservation/voucher/recipient-suggestion',
  RESERVATION_VOUCHER_SEND = '/reservation/voucher/:reservationId/send',

  RESERVATION_LOCK_KEYS_OVERVIEW = '/reservation/lock/:reservationId/keys-overview',
  RESERVATION_LOCK_RESERVATION_KEYS = '/reservation/lock/:reservationId/reservation-keys',
  RESERVATION_LOCK_RESERVATION_LOCK_CAPABILITIES = '/reservation/lock/:reservationId/reservation-lock-capabilities',
  RESERVATION_LOCK_CANCEL_ALL_KEYS = '/reservation/lock/:reservationRoomId/cancel-all-keys',
  RESERVATION_LOCK_CANCEL_CARD = '/reservation/lock/:reservationRoomId/cancel-card',
  RESERVATION_LOCK_ISSUE_PIN = '/reservation/lock/:reservationRoomId/issue-pin',
  RESERVATION_LOCK_ISSUE_CARD = '/reservation/lock/:reservationRoomId/issue-card',
  RESERVATION_LOCK_ISSUE_ALFRED_KEY = '/reservation/lock/:reservationRoomId/issue-alfred-key',

  INVOICING_VAT_CLASSIFICATIONS = '/invoicing/vat-classifications',
  INVOICING_ACCOUNT_ASSIGNMENTS = '/invoicing/account-assignments',
  INVOICING_SERVICE_CLASSIFICATIONS = '/invoicing/service-classifications',
  INVOICING_GTU_CODES = '/invoicing/gtu-codes',

  USER_AUTH_LOGIN = '/user/auth/login',
  USER_AUTH_LOGOUT = '/user/auth/logout',
  USER_AUTH_REFRESH = '/user/auth/refresh',
  USER_USER_CURRENT = '/user/user/current',
  USER_USER_CHANGE_LANGUAGE = '/user/user/change-language',
  USER_NOTIFICATION_PUSHER_BEAMS_TOKEN = '/user/notification/:userId/pusher-beams-token',
  USER_NOTIFICATION_SUBSCRIBE = '/user/notification/subscribe',
  USER_NOTIFICATION_UNSUBSCRIBE = '/user/notification/unsubscribe',
  USER_NOTIFICATION_ACTIVATE = '/user/notification/activate',
  USER_NOTIFICATION_DEACTIVATE = '/user/notification/deactivate',

  USERS = '/users/users',
  COMPANY_USERS = '/users/users/company-users/:companyId',

  ROLES = '/roles/roles',

  PROPERTY_PROPERTY_DETAIL = '/property/property/:propertyId',
  PROPERTY_PROPERTIES_LIST = '/property/properties/list',
  PROPERTY_PROPERTIES_SUGGEST = '/property/properties/suggest',
  PROPERTY_PROPERTIES_PROPERTY_GROUP_LIST = '/property/properties/propertyGroup',
  PROPERTY_STAY_PACKAGES_LIST = '/property/stay-packages',
  PROPERTY_STAY_PACKAGES_SUGGESTIONS = '/property/stay-packages/suggestions',
  PROPERTY_SERVICES_LIST = '/property/services',
  PROPERTY_SERVICES_BY_OBJECT_KINDS_LIST = '/property/services/by-object-kinds',
  PROPERTY_SERVICE_ACCOUNTING = '/property/services/:serviceId/accounting',
  PROPERTY_OBJECT_ROOMS_LIST = '/property/object-rooms',
  PROPERTY_OBJECT_KINDS_LIST = '/property/object-kinds',
  PROPERTY_PARTNERS_LIST = '/property/partners',
  PROPERTY_GUEST_CATEGORIES_LIST = '/property/guest-categories',
  PROPERTY_MARKET_CODES_LIST = '/property/market-codes',
  PROPERTY_BANK_ACCOUNTS = '/property/bank-accounts',
  PROPERTY_TERMINALS_ACTIVE = '/property/terminals/active',
  PROPERTY_HOUSEKEEPING_CLEANING_LIST = '/property/housekeeping/cleaning',
  PROPERTY_HOUSEKEEPING_CLEANING_EXPORT = '/property/housekeeping/cleaning/export',
  PROPERTY_HOUSEKEEPING_CLEANING_OBJECT_TIDINESS_STATUS = '/property/housekeeping/cleaning/tidiness-status',
  PROPERTY_HOUSEKEEPING_CLEANING_TIDINESS_STATUSES = '/property/housekeeping/cleaning/tidiness-statuses',
  PROPERTY_HOUSEKEEPING_CLEANING_SETTINGS = '/property/housekeeping/cleaning/settings',
  PROPERTY_HOUSEKEEPING_DEFECTS_LIST = '/property/housekeeping/defects',
  PROPERTY_HOUSEKEEPING_DEFECTS_ACTIVE_PER_OBJECT_ROOM = '/property/housekeeping/defects/active-per-object-room',
  PROPERTY_HOUSEKEEPING_DEFECTS_EXPORT = '/property/housekeeping/defects/export',
  PROPERTY_HOUSEKEEPING_DEFECT_CREATE = '/property/housekeeping/defect',
  PROPERTY_HOUSEKEEPING_DEFECT_DETAIL = '/property/housekeeping/defect/:defectId',
  PROPERTY_HOUSEKEEPING_DEFECT_UPDATE = '/property/housekeeping/defect/:defectId',
  PROPERTY_HOUSEKEEPING_DEFECT_DELETE = '/property/housekeeping/defect/:defectId',
  PROPERTY_HOUSEKEEPING_DEFECT_STATUS = '/property/housekeeping/defect/:defectId/status',
  PROPERTY_HOUSEKEEPING_DEFECT_PHOTO_UPLOAD = '/property/housekeeping/defect-photo',
  PROPERTY_HOUSEKEEPING_TASKS_LIST = '/property/housekeeping/tasks',
  PROPERTY_HOUSEKEEPING_TASKS_ACTIVE_PER_OBJECT_ROOM = '/property/housekeeping/tasks/active-per-object-room',
  PROPERTY_HOUSEKEEPING_TASKS_ACTIVE_PER_OBJECT_ROOM_FOR_RESERVATIONS = '/property/housekeeping/tasks/active-per-object-room-for-reservations',
  PROPERTY_HOUSEKEEPING_TASK_CREATE = '/property/housekeeping/task',
  PROPERTY_HOUSEKEEPING_TASK_GET = '/property/housekeeping/task/:taskId',
  PROPERTY_HOUSEKEEPING_TASK_UPDATE = '/property/housekeeping/task/:taskId',
  PROPERTY_HOUSEKEEPING_TASK_DELETE = '/property/housekeeping/task/:taskId',
  PROPERTY_HOUSEKEEPING_TASK_STATUS = '/property/housekeeping/task/:taskId/status',
  PROPERTY_HOUSEKEEPING_TASK_REQUEST_ACCESS = '/property/housekeeping/tasks-upsell/request-access',
  PROPERTY_HOUSEKEEPING_TASKS_EXPORT = '/property/housekeeping/tasks/export',
  PROPERTY_HOUSEKEEPING_TASK_TEMPLATES_LIST = '/property/housekeeping/task-templates',
  PROPERTY_HOUSEKEEPING_TASK_TEMPLATE_DETAIL = '/property/housekeeping/task-template/:taskTemplateId',
  PROPERTY_HOUSEKEEPING_TASK_TEMPLATE_CREATE = '/property/housekeeping/task-template',
  PROPERTY_HOUSEKEEPING_TASK_TEMPLATE_UPDATE = '/property/housekeeping/task-template/:taskTemplateId',
  PROPERTY_HOUSEKEEPING_TASK_TEMPLATE_DELETE = '/property/housekeeping/task-template/:taskTemplateId',
  PROPERTY_HOUSEKEEPING_APP_ASSIGNMENTS_LIST = '/settings/applications/housekeeping/app/assignments',
  PROPERTY_HOUSEKEEPING_APP_ASSIGNMENT_DETAIL = '/settings/applications/housekeeping/app/assignment/:assignmentId',
  PROPERTY_HOUSEKEEPING_APP_PERMANENT_ASSIGNMENT_CREATE = '/settings/applications/housekeeping/app/assignment/permanent',
  PROPERTY_HOUSEKEEPING_APP_TEMPORARY_ASSIGNMENTS_CREATE = '/settings/applications/housekeeping/app/assignments/temporary',
  PROPERTY_HOUSEKEEPING_APP_PERMANENT_ASSIGNMENT_UPDATE = '/settings/applications/housekeeping/app/assignment/permanent/:assignmentId',
  PROPERTY_HOUSEKEEPING_APP_TEMPORARY_ASSIGNMENT_UPDATE = '/settings/applications/housekeeping/app/assignment/temporary/:assignmentId',
  PROPERTY_HOUSEKEEPING_APP_ASSIGNMENT_DELETE = '/settings/applications/housekeeping/app/assignment/:assignmentId',
  PROPERTY_HOUSEKEEPING_SETTINGS_GET = '/settings/applications/housekeeping/general/settings',
  PROPERTY_HOUSEKEEPING_SETTINGS_UPDATE = '/settings/applications/housekeeping/general/settings',
  PROPERTY_SETTINGS_ALFRED = '/property/settings/alfred',
  PROPERTY_SETTINGS_MODULES = '/property/settings/active-modules',
  PROPERTY_SETTINGS_WHATSAPP = '/property/settings/whatsapp',
  PROPERTY_SALESMAN_GET = '/property/settings/salesman',
  PROPERTY_AGENCY_SETTINGS_GET = '/settings/applications/guests-and-companies/agency',
  PROPERTY_AGENCY_SETTINGS_UPDATE = '/settings/applications/guests-and-companies/agency',
  PROPERTY_AGENCY_SETTINGS_FORMULA_UPDATE = '/settings/applications/guests-and-companies/agency/formula',
  PROPERTY_AGENCY_REQUEST_ACTIVATION = '/settings/applications/guests-and-companies/agency/request-activation',

  PRICING_DISCOUNT_CODES_LIST = '/pricing/discount-codes',
  PRICING_RATE_PLAN_LIST = '/pricing/rate-plans',
  PRICING_OTA_RATE_PLANS = '/pricing/rate-plans/ota/:otaId',
  PRICING_MEAL_RATE_PLAN_LIST = '/pricing/meal-rate-plans',
  PRICING_GUEST_RATE_PLAN_LIST = '/pricing/rate-plans',
  PRICING_TAX_SETTINGS_LIST = '/pricing/tax-settings',
  PRICING_TAX_SETTINGS_BY_DATE = '/pricing/tax-settings/:date',
  PRICING_LOCAL_TAX_EXEMPTIONS = '/pricing/local-tax-exemptions',
  PRICING_TAX_PERIODS = '/pricing/tax-periods',
  PRICING_TAX_PERIODS_HISTORY = '/pricing/tax-periods/history',
  PRICING_TAX_PERIOD_DETAIL = '/pricing/tax-periods/:taxPeriodId',

  CURRENCY_EXCHANGE_RATES = '/reservation/currency/exchange-rates',

  CUSTOMER_CONTACT_PERSON_RESERVATIONS_LIST = '/customer/contact-person/:customerId/reservations',
  CUSTOMER_CONTACT_PERSON_DETAIL = '/customer/contact-person/:contactPersonId',
  CUSTOMER_CONTACT_PERSON_CREATE = '/customer/contact-person',
  CUSTOMER_CONTACT_PERSON_UPDATE = '/customer/contact-person/:contactPersonId',
  CUSTOMER_CONTACT_PERSON_DELETE = '/customer/contact-person/:contactPersonId',
  CUSTOMER_CONTACT_PERSON_USER_LOGS = '/customer/contact-person/:contactPersonId/user-logs',
  CUSTOMER_CONTACT_PERSON_LOG_BODIES = '/customer/contact-person/log-bodies',
  CUSTOMER_CONTACT_PERSONS_LIST = '/customer/contact-persons',
  CUSTOMER_CONTACT_PERSONS_EXPORT = '/customer/contact-persons/export',
  CUSTOMER_CONTACT_PERSONS_BULK_DELETE = '/customer/contact-persons/bulk-delete',
  CUSTOMER_CONTACT_PERSONS_MERGE = '/customer/contact-persons/merge',
  CUSTOMER_CONTACT_PERSONS_SUGGESTION = '/customer/contact-persons/suggestion',

  CUSTOMER_STAT_OFFICE_REPORT_CZ_LIST = '/customer/stat-office-report-cz',
  CUSTOMER_STAT_OFFICE_REPORT_CZ_DELETE = '/customer/stat-office-report-cz/:id',
  CUSTOMER_STAT_OFFICE_REPORT_CZ_DETAIL = '/customer/stat-office-report-cz/:id',
  CUSTOMER_STAT_OFFICE_REPORT_CZ_UPDATE = '/customer/stat-office-report-cz/:id',
  CUSTOMER_STAT_OFFICE_REPORT_CZ_EXPORT_XML = '/customer/stat-office-report-cz/:id/export-xml',
  CUSTOMER_STAT_OFFICE_REPORT_CZ_SEND = '/customer/stat-office-report-cz/:id/send',
  CUSTOMER_STAT_OFFICE_REPORT_CZ_API_STATUS = '/customer/stat-office-report-cz/:id/api-status',
  CUSTOMER_STAT_OFFICE_REPORT_CZ_ISSUE = '/customer/stat-office-report-cz/issue',
  CUSTOMER_STAT_OFFICE_REPORT_CZ_SETTINGS_GET = '/customer/stat-office-report-cz/settings',
  CUSTOMER_STAT_OFFICE_REPORT_CZ_SETTINGS_UPDATE = '/customer/stat-office-report-cz/settings',

  SELF_SERVICE_BAR_PROPERTY_INFO = '/settings/applications/self-service-bar/property-info',
  SELF_SERVICE_BAR_DETAIL = '/settings/applications/self-service-bar/bar/:barId',
  SELF_SERVICE_BAR_DELETE = '/settings/applications/self-service-bar/bar/:barId',
  SELF_SERVICE_BAR_CREATE = '/settings/applications/self-service-bar/bar',
  SELF_SERVICE_BAR_UPDATE = '/settings/applications/self-service-bar/bar/:barId',
  SELF_SERVICE_BAR_LIST = '/settings/applications/self-service-bar/bars',

  POS_TABLE_LIST = '/settings/applications/pos/tables',
  POS_TABLE_CREATE = '/settings/applications/pos/tables',
  POS_TABLE_UPDATE = '/settings/applications/pos/tables/:id',
  POS_TABLE_DELETE = '/settings/applications/pos/tables/:id',

  CONNECTED_ROOMS_CONNECTION_LIST = '/settings/applications/connected-rooms/connections',
  CONNECTED_ROOMS_CONNECTION_CREATE = '/settings/applications/connected-rooms/connections',
  CONNECTED_ROOMS_CONNECTION_UPDATE = '/settings/applications/connected-rooms/connections/:id',
  CONNECTED_ROOMS_CONNECTION_ACTIVITY = '/settings/applications/connected-rooms/connections/:id/activity',
  CONNECTED_ROOMS_CONNECTION_DELETE = '/settings/applications/connected-rooms/connections/:id',
  CONNECTED_ROOMS_SETTINGS_GET = '/settings/applications/connected-rooms/settings',
  CONNECTED_ROOMS_SETTINGS_UPDATE = '/settings/applications/connected-rooms/settings',
  CONNECTED_ROOMS_FAILURE_LIST = '/settings/applications/connected-rooms/failures',
  CONNECTED_ROOMS_FAILURE_RETRY = '/settings/applications/connected-rooms/failures/retry',

  ONLINE_RESERVATION_BOOKING_LATEST_BY = '/online-reservation/booking/setting/online-booking-latest-by',
  ONLINE_RESERVATION_SETTINGS_BASIC = '/online-reservation/booking/setting',
  ONLINE_RESERVATION_SETTINGS_UPDATE = '/online-reservation/booking/setting/:propertyId',

  ONLINE_RESERVATION_FORM_CONFIGURATIONS_LIST = '/online-reservation/booking/form-configurations/list',
  ONLINE_RESERVATION_FORM_CONFIGURATION_BASIC = '/online-reservation/booking/form-configuration',
  ONLINE_RESERVATION_FORM_CONFIGURATION_UUID = '/online-reservation/booking/form-configuration/:formConfigurationId',

  ONLINE_RESERVATION_COUPON_LIST = '/online-reservation/booking/coupon/list',
  ONLINE_RESERVATION_PROPERTY_INFO = '/settings/applications/online-reservation/property-info/detail',
  ONLINE_RESERVATION_REQUEST_ACTIVATION = '/settings/applications/online-reservation/request-activation',

  PROPERTY_SETTINGS_BOOK_ONLINE = '/property/settings/book-online',

  CHANNEL_MANAGER_MY_CONNECTION_DATA_TABLE = '/settings/applications/channel-manager/my-connections/connections/list',
  CHANNEL_MANAGER_MY_CONNECTION_RATE_PLANS = '/settings/applications/channel-manager/my-connections/connections/rate-plans',

  CHANNEL_MANAGER_MY_CONNECTION_DETAIL = '/settings/applications/channel-manager/my-connections/connection/:otaId',
  CHANNEL_MANAGER_MY_CONNECTION_YIELD_PLANET_DETAIL = '/settings/applications/channel-manager/my-connections/yield-planet/connection',
  CHANNEL_MANAGER_MY_CONNECTION_API_CHANGE_REQUEST = '/settings/applications/channel-manager/my-connections/connection/:otaId/api-change-request',
  CHANNEL_MANAGER_MY_CONNECTION_CHM_DELETE_REQUEST = '/settings/applications/channel-manager/my-connections/connection/:profileId/chm-delete-request',
  CHANNEL_MANAGER_MY_CONNECTION_API_DELETE_REQUEST = '/settings/applications/channel-manager/my-connections/connection/:otaId/api-delete-request',
  CHANNEL_MANAGER_MY_CONNECTION_YIELD_PLANET_DELETE_REQUEST = '/settings/applications/channel-manager/my-connections/yield-planet/connection/:yieldPlanetPartnerId/delete-request',

  CHANNEL_MANAGER_MY_CONNECTIONS_MAPPING_LIST = '/settings/applications/channel-manager/my-connections/mapping/:profileId/list',
  CHANNEL_MANAGER_MY_CONNECTIONS_MAPPING_OBJECT_KINDS = '/settings/applications/channel-manager/my-connections/mapping/:otaId/object-kinds',
  CHANNEL_MANAGER_MY_CONNECTIONS_MAPPING_RATE_PLANS = '/settings/applications/channel-manager/my-connections/mapping/:profileId/rate-plans',
  CHANNEL_MANAGER_MY_CONNECTIONS_MAPPING_ROOM_TYPES = '/settings/applications/channel-manager/my-connections/mapping/:profileId/room-types',
  CHANNEL_MANAGER_MY_CONNECTIONS_MAPPING_UNMAPPED_ROOMS = '/settings/applications/channel-manager/my-connections/mapping/:profileId/unmapped-rooms',
  CHANNEL_MANAGER_MY_CONNECTIONS_MAPPING_UNMAPPED_RATE_PLANS = '/settings/applications/channel-manager/my-connections/mapping/:profileId/unmapped-rate-plans',
  CHANNEL_MANAGER_MY_CONNECTIONS_MAPPING_COMBINATIONS = '/settings/applications/channel-manager/my-connections/mapping/:profileId/combinations',
  CHANNEL_MANAGER_MY_CONNECTIONS_MAPPING_ROOMS = '/settings/applications/channel-manager/my-connections/mapping/:profileId/rooms',
  CHANNEL_MANAGER_MY_CONNECTIONS_MAPPING_SAVE = '/settings/applications/channel-manager/my-connections/mapping/:profileId/mappings',
  CHANNEL_MANAGER_MY_CONNECTIONS_YIELD_PLANET_MAPPING_LIST = '/settings/applications/channel-manager/my-connections/yield-planet/mapping/:yieldPlanetPartnerId/list',
  CHANNEL_MANAGER_MY_CONNECTIONS_MAPPING_REQUEST_EDIT = '/settings/applications/channel-manager/my-connections/mapping/:mappingId/request-edit',
  CHANNEL_MANAGER_MY_CONNECTIONS_YIELD_PLANET_MAPPING_REQUEST_EDIT = '/settings/applications/channel-manager/my-connections/yield-planet/mapping/:mappingId/request-edit',

  CHANNEL_MANAGER_SERVICE_MAPPING_CHANNEL_MANAGER_STATE = '/settings/applications/channel-manager/service-mapping/channel-manager-state',
  CHANNEL_MANAGER_SERVICE_MAPPING_LIST = '/settings/applications/channel-manager/service-mapping/list',
  CHANNEL_MANAGER_SERVICE_MAPPING_DETAIL = '/settings/applications/channel-manager/service-mapping/:otaId',
  CHANNEL_MANAGER_SERVICE_MAPPING_MAPPINGS = '/settings/applications/channel-manager/service-mapping/mappings',

  CHANNEL_MANAGER_MARKETPLACE_LIST = '/settings/applications/channel-manager/marketplace/list',
  CHANNEL_MANAGER_MARKETPLACE_REQUEST_NEW_CONNECTION = '/settings/applications/channel-manager/marketplace/request-new-connection',

  SETTINGS_NOTIFICATIONS_RESERVATION = '/settings/notifications/reservation',
  SETTINGS_NOTIFICATIONS_RESERVATION_SAVE = '/settings/notifications/reservation/save',

  CUSTOMER_COMPANY_DETAIL = '/customer/company/:companyId',
  CUSTOMER_COMPANY_SUGGEST = '/customer/company/:companyId/suggest',
  CUSTOMER_COMPANY_CREATE = '/customer/company',
  CUSTOMER_COMPANY_UPDATE = '/customer/company/:companyId',
  CUSTOMER_COMPANY_RESERVATION_SUMMARY = '/customer/company/:companyId/reservation-summary',
  CUSTOMER_COMPANY_CHECK_DUPLICITY = '/customer/company/check-duplicity',
  CUSTOMER_COMPANIES_LIST = '/customer/companies',
  CUSTOMER_COMPANY_DELETE = '/customer/companies/bulk-delete',
  CUSTOMER_COMPANY_TAGS = '/customer/company-tags',
  CUSTOMER_MARKET_CODES = '/customer/market-codes',
  CUSTOMER_COMPANY_DATA_FROM_REGISTER = '/customer/company-data-from-register',
  CUSTOMER_COMPANIES_SUGGEST = '/customer/companies/suggest',
  CUSTOMER_COMPANY_MANUAL_MERGE = '/customer/companies/merge',
  CUSTOMER_COMPANY_RATE_PLAN_LIST = '/customer/companies/rate-plan-list',
  CUSTOMER_COMPANY_LABEL_LIST = '/customer/companies/label-list',
  CUSTOMER_COMPANY_USER_LIST = '/customer/companies/users-list',
  CUSTOMER_COMPANY_ADVANCED_SETTINGS = '/customer/companies/:companyId/advanced-system-settings',
  CUSTOMER_COMPANY_MARKET_CODE_LIST = '/customer/companies/market-code-list',
  CUSTOMER_COMPANY_GROUP_HOTEL_LIST = '/customer/companies/group-properties-list',
  CUSTOMER_COMPANY_EXPORT = '/customer/companies/export',
  CUSTOMER_COMPANY_ACTIVITY = '/customer/company/:companyId/company-activity',
  CUSTOMER_COMPANY_ACTIVITY_BODIES = '/customer/company/activity-bodies',

  CUSTOMER_COMMUNICATION_TEMPLATE_GET_LIST = '/customer/communication/campaign',
  CUSTOMER_COMMUNICATION_TEMPLATE_CREATE = '/customer/communication/campaign',
  CUSTOMER_COMMUNICATION_TEMPLATE_DEFAULT_SENDER = '/customer/communication/campaign/default-sender',
  CUSTOMER_COMMUNICATION_TEMPLATE_GET_ONE = '/customer/communication/campaign/:campaignId',
  CUSTOMER_COMMUNICATION_TEMPLATE_UPDATE = '/customer/communication/campaign/:campaignId',
  CUSTOMER_COMMUNICATION_TEMPLATE_COPY = '/customer/communication/campaign/:campaignId/copy',
  CUSTOMER_COMMUNICATION_TEMPLATE_RESTORE_DEFAULT_TEMPLATE = '/customer/communication/campaign/:campaignId/restore-default-template',
  CUSTOMER_COMMUNICATION_TEMPLATE_CHANGE_STATUS = '/customer/communication/campaign/:campaignId/status',
  CUSTOMER_COMMUNICATION_TEMPLATE_DELETE = '/customer/communication/campaign/:campaignId',
  CUSTOMER_COMMUNICATION_TEMPLATE_TEST_EMAIL = '/customer/communication/campaign/test-email',
  CUSTOMER_COMMUNICATION_TEMPLATE_DRAFT_TEST_EMAIL = '/customer/communication/campaign/test-email/draft',
  CUSTOMER_COMMUNICATION_TEMPLATE_DEFAULT_TEMPLATE_TEST_EMAIL = '/customer/communication/campaign/:campaignId/default-template/test-email',
  CUSTOMER_COMMUNICATION_TEMPLATE_UPLOAD_ATTACHMENTS = '/customer/communication/campaign/:campaignId/attachment',
  CUSTOMER_COMMUNICATION_TEMPLATE_VALIDATE_SPF = '/customer/communication/campaign/validate-spf',
  CUSTOMER_COMMUNICATION_SYSTEM_MESSAGE_DEFAULT_TEMPLATE = '/customer/communication/system-message/:type/default-template',
  CUSTOMER_COMMUNICATION_SENT_EMAIL_LIST = '/customer/communication/sent-email',
  CUSTOMER_COMMUNICATION_SENT_EMAIL_ERROR = '/customer/communication/sent-email/:messageId/error',
  CUSTOMER_COMMUNICATION_MARKET_CODES_LIST = '/customer/communication/codebook/market-codes',
  CUSTOMER_COMMUNICATION_PLACEHOLDERS_LIST = '/customer/communication/codebook/placeholders',
  CUSTOMER_COMMUNICATION_GUEST_TAGS_LIST = '/customer/communication/codebook/guest-tags',
  CUSTOMER_COMMUNICATION_SERVICE_IN_ACCOUNT_LIST = '/customer/communication/codebook/services-in-account',
  CUSTOMER_COMMUNICATION_STOCK_ITEM_LIST = '/customer/communication/codebook/stock-item',
  CUSTOMER_COMMUNICATION_STAY_PACKAGE_LIST = '/customer/communication/codebook/stay-package',
  CUSTOMER_COMMUNICATION_COMPANY_LIST = '/customer/communication/codebook/company',
  CUSTOMER_COMMUNICATION_ATTACHMENT_MIME_TYPES_LIST = '/customer/communication/codebook/attachment-mime-types',
  CUSTOMER_COMMUNICATION_RECIPIENTS_LIST = '/customer/communication/campaign/:campaignId/recipients',
  CUSTOMER_COMMUNICATION_RECIPIENTS_COUNT = '/customer/communication/campaign/:campaignId/recipients/count',
  CUSTOMER_COMMUNICATION_CONTENT_BUILDER_IMAGE_UPLOAD = '/customer/communication/content-builder/campaign/:campaignId/image',
  CUSTOMER_COMMUNICATION_CONTENT_BUILDER_IMAGE_UPLOAD_BASE64 = '/customer/communication/content-builder/campaign/:campaignId/image/base64',
  CUSTOMER_COMMUNICATION_CONTENT_BUILDER_IMAGE_UPLOAD_GENERATED = '/customer/communication/content-builder/campaign/:campaignId/image/generated',
  CUSTOMER_COMMUNICATION_CONTENT_BUILDER_IMAGE_DELETE = '/customer/communication/content-builder/campaign/:campaignId/image',
  CUSTOMER_COMMUNICATION_CONTENT_BUILDER_AI_KEYS = '/customer/communication/content-builder/ai/keys',
  CUSTOMER_COMMUNICATION_CONTENT_BUILDER_AI_COMMAND = '/customer/communication/content-builder/ai/command',
  CUSTOMER_COMMUNICATION_CONTENT_BUILDER_AI_FAL_REQUEST = '/customer/communication/content-builder/ai/fal/request',
  CUSTOMER_COMMUNICATION_CONTENT_BUILDER_AI_FAL_STATUS = '/customer/communication/content-builder/ai/fal/status',
  CUSTOMER_COMMUNICATION_CONTENT_BUILDER_AI_FAL_RESULT = '/customer/communication/content-builder/ai/fal/result',

  CUSTOMER_GUEST_DETAIL = '/customer/guest/:guestId',
  CUSTOMER_GUEST_CREATE = '/customer/guest',
  CUSTOMER_GUEST_UPDATE = '/customer/guest/:guestId',
  CUSTOMER_GUEST_DELETE = '/customer/guest/:guestId',
  CUSTOMER_GUESTS_CAN_DELETE = '/customer/guests/can-be-deleted',
  CUSTOMER_GUESTS_DELETE_VALIDATION_DETAILS = '/customer/guests/delete-validation-details',
  CUSTOMER_GUESTS_LIST = '/customer/guests',
  CUSTOMER_GUEST_TAGS = '/customer/guest-tags',
  CUSTOMER_GUESTS_SUGGEST = '/customer/guests/suggest',
  CUSTOMER_GUEST_MANUAL_MERGE = '/customer/guests/merge',
  CUSTOMER_GUESTS_EXPORT = '/customer/guests/export',
  CUSTOMER_GUESTS_GROUP_PROPERTIES = '/customer/guests/group-properties-list',
  CUSTOMER_GUESTS_DUPLICITIES = '/customer/guests/duplicities',
  CUSTOMER_GUESTS_DUPLICITIES_MERGE = '/customer/guests/duplicities/merge',
  CUSTOMER_GUESTS_DUPLICITIES_DISMISS = '/customer/guests/duplicities/dismiss',
  CUSTOMER_GUEST_RESERVATIONS_LIST = '/customer/guest/:customerId/reservations',
  CUSTOMER_GUEST_USER_LOGS = '/customer/guest/:guestId/user-logs',
  CUSTOMER_GUEST_LOG_BODIES = '/customer/guest/log-bodies',

  CUSTOMER_PROPERTY_GET = '/customer/property/:propertyId',

  INVOICING_GIFT_VOUCHERS_LIST = '/invoicing/gift-voucher/gift-vouchers/list',
  INVOICING_GIFT_VOUCHERS_SUMMARY = '/invoicing/gift-voucher/gift-vouchers/summary',
  INVOICING_GIFT_VOUCHERS_DETAIL = '/invoicing/gift-voucher/gift-vouchers/:giftVoucherId',
  INVOICING_GIFT_VOUCHER_CREATE = '/invoicing/gift-voucher/gift-voucher',
  INVOICING_GIFT_VOUCHER_INTERNAL_NOTE_UPDATE = '/invoicing/gift-voucher/gift-voucher/:giftVoucherId/internal-note',
  INVOICING_GIFT_VOUCHER_PAYMENT_UPDATE = '/invoicing/gift-voucher/gift-voucher/:giftVoucherId/payment',
  INVOICING_GIFT_VOUCHER_DOCUMENT_INFORMATION_UPDATE = '/invoicing/gift-voucher/gift-voucher/:giftVoucherId/document-information',
  INVOICING_GIFT_VOUCHER_SUPPLIER_INFORMATION_UPDATE = '/invoicing/gift-voucher/gift-voucher/:giftVoucherId/supplier-information',
  INVOICING_GIFT_VOUCHER_BUYER = '/invoicing/gift-voucher/gift-voucher/:giftVoucherId/buyer',
  INVOICING_GIFT_VOUCHER_BUYER_UPDATE = '/invoicing/gift-voucher/gift-voucher/:giftVoucherId/buyer',
  INVOICING_GIFT_VOUCHER_BUYER_GUEST_RECORD_UPDATE = '/invoicing/gift-voucher/gift-voucher/buyer/guest/:guestId',
  INVOICING_GIFT_VOUCHER_BUYER_COMPANY_RECORD_UPDATE = '/invoicing/gift-voucher/gift-voucher/buyer/company/:companyId',
  INVOICING_GIFT_VOUCHER_CONTENT_UPDATE = '/invoicing/gift-voucher/gift-voucher/:giftVoucherId/content',
  INVOICING_DOCUMENTS_LIST = '/invoicing/document/documents/list',
  INVOICING_DOCUMENTS_SUGGEST = '/invoicing/document/documents/suggest',
  INVOICING_DOCUMENTS_SUMMARY = '/invoicing/document/documents/summary',
  INVOICING_DOCUMENTS_EXPORT = '/invoicing/document/documents/export',
  INVOICING_DOCUMENT_BUYER_GUEST_DETAIL = '/invoicing/document/documents/buyer/guest/:guestId',
  INVOICING_DOCUMENT_BUYER_GUEST_UPDATE = '/invoicing/document/documents/buyer/guest/:guestId',
  INVOICING_DOCUMENT_BUYER_COMPANY_DETAIL = '/invoicing/document/documents/buyer/company/:companyId',
  INVOICING_DOCUMENT_BUYER_COMPANY_UPDATE = '/invoicing/document/documents/buyer/company/:companyId',
  INVOICING_PAYMENT_PRESCRIPTION_LIST = '/invoicing/payment-prescription/reservation/:reservationId/list',
  INVOICING_PAYMENT_PRESCRIPTION_CREATE = '/invoicing/payment-prescription',
  INVOICING_PAYMENT_PRESCRIPTION_EMAIL_BODY = '/invoicing/payment-prescription/email-body',
  INVOICING_PAYMENT_PRESCRIPTION_ISSUE_DATA = '/invoicing/payment-prescription/reservation/:reservationId/issue-data',
  INVOICING_PAYMENT_PRESCRIPTION_CANCEL = '/invoicing/payment-prescription/:prescriptionId/cancel',
  INVOICING_CLOSURES = '/invoicing/closure/closures/list',
  INVOICING_NUMBERING_EMAIL_RECIPIENTS = '/invoicing/document/numbering/email-recipients/:documentId',
  INVOICING_NUMBERING_EMAIL_TEXT = '/invoicing/document/numbering/email-text/:numberingId/:languageId',
  INVOICING_NUMBERINGS = '/invoicing/document/numberings/list',
  INVOICING_NUMBERINGS_NEXT = '/invoicing/document/numberings/next',
  INVOICING_SUPPLIERS = '/invoicing/document/suppliers/list',
  INVOICING_SUPPLIER_DETAIL = '/invoicing/document/suppliers/detail',
  INVOICING_CONNECTED_PAYMENTS = '/invoicing/document/connected-payments',
  INVOICING_RELATED_DOCUMENTS = '/invoicing/document/document/related-documents',
  INVOICING_RELATED_DOCUMENT_PREFILL = '/invoicing/document/:documentId/related-document-prefill',
  INVOICING_RELATED_DOCUMENT_UNLINK = '/invoicing/document/document/:documentId/related/:relatedDocumentId',
  INVOICING_DATA_FOR_DELETING = '/invoicing/document/data-for-deleting',
  INVOICING_DOCUMENT_ITEM_SUGGESTIONS = '/invoicing/document/items/suggestions',
  INVOICING_DOCUMENT_ITEMS_LIST = '/invoicing/document/items/list',
  INVOICING_DOCUMENT_ITEM_CREATE = '/invoicing/document/:documentId/item',
  INVOICING_DOCUMENT_ITEM_UPDATE = '/invoicing/document/:documentId/item/:accountItemId',
  INVOICING_DOCUMENT_ITEM_DELETE = '/invoicing/document/:documentId/item/:accountItemId',
  INVOICING_DOCUMENT_CREATE = '/invoicing/document/document',
  INVOICING_DOCUMENT_CREDIT_NOTE_ADVANCE_ITEM_NAMES = '/invoicing/document/credit-note-advance-item-names',
  INVOICING_DOCUMENT_DETAIL = '/invoicing/document/:documentId',
  INVOICING_DOCUMENT_NOTE_UPDATE = '/invoicing/document/:documentId/note',
  INVOICING_DOCUMENT_CURRENCY_UPDATE = '/invoicing/document/:documentId/currency',
  INVOICING_DOCUMENT_SECONDARY_CURRENCY_UPDATE = '/invoicing/document/:documentId/secondary-currency',
  INVOICING_DOCUMENT_DELETE = '/invoicing/document/:documentId',
  INVOICING_DOCUMENT_INFORMATION_DETAIL = '/invoicing/document/:documentId/information',
  INVOICING_DOCUMENT_INFORMATION_EDIT = '/invoicing/document/:documentId/information',
  INVOICING_DOCUMENT_SUPPLIER_EDIT = '/invoicing/document/:documentId/supplier',
  INVOICING_DOCUMENT_CHANGE_PAYMENT_DETAILS = '/invoicing/document/:documentId/payment-details',
  INVOICING_DOCUMENT_UPDATE_BUYER = '/invoicing/document/:documentId/buyer',
  INVOICING_DOCUMENT_BUYER = '/invoicing/document/:documentId/buyer',
  INVOICING_DOCUMENT_CHANGE_DATES = '/invoicing/document/:documentId/dates',
  INVOICING_DOCUMENT_PAY = '/invoicing/document/:documentId/pay',
  INVOICING_TERMINAL_PAYMENT_START = '/invoicing/terminal-payment/start',
  INVOICING_TERMINAL_PAYMENT_PROGRESS = '/invoicing/terminal-payment/progress',
  INVOICING_TERMINAL_PAYMENT_CANCEL = '/invoicing/terminal-payment/cancel',
  INVOICING_TERMINAL_PAYMENT_RELEASE = '/invoicing/terminal-payment/release',
  INVOICING_TERMINAL_PAYMENT_FINISH = '/invoicing/terminal-payment/document/:documentId/finish',
  INVOICING_DOCUMENT_FISCALIZE = '/invoicing/document/:documentId/fiscalize',
  INVOICING_DOCUMENT_FISCALIZE_RESEND = '/invoicing/document/:documentId/fiscalize/resend',
  INVOICING_DOCUMENT_FISCALIZE_CANCEL = '/invoicing/document/:documentId/fiscalize/cancel',
  INVOICING_DOCUMENT_FISCALIZATION_SETTING = '/invoicing/document/fiscalization/setting',
  INVOICING_DOCUMENT_FISCALIZE_HISTORY = '/invoicing/document/:documentId/fiscalize/history',
  INVOICING_DOCUMENT_VAT_RECAPITULATION = '/invoicing/document/:documentId/vat-recapitulation',
  INVOICING_DOCUMENT_ADVANCE_ADD = '/invoicing/document/document/:documentId/advance',
  INVOICING_DOCUMENT_ADVANCE_REMOVE = '/invoicing/document/document/:documentId/advance/:advanceDocumentId',
  INVOICING_DOCUMENT_BILLABLE_RESERVATIONS = '/invoicing/document/billable-reservations',
  INVOICING_DOCUMENT_PREFILL_FROM_RESERVATIONS = '/invoicing/document/prefill/from-reservations',
  INVOICING_DOCUMENT_MERGE_ITEMS = '/invoicing/document/:documentId/merge-items',
  INVOICING_DOCUMENT_SPLIT_ITEMS = '/invoicing/document/:documentId/split-items',
  INVOICING_CURRENCY_EXCHANGE_RATES = '/invoicing/currency/exchange-rates',
  INVOICING_CURRENCY_CONVERT_PRICES = '/invoicing/currency/convert-prices',
  INVOICING_DOCUMENT_EXPORT = '/invoicing/document/export',
  INVOICING_DOCUMENT_EXPORT_PREVIEW = '/invoicing/document/export/preview',
  INVOICING_DOCUMENT_SEND = '/invoicing/document/export/send',
  INVOICING_DOCUMENT_SEND_PREVIEW = '/invoicing/document/export/send/preview',
  INVOICING_DOCUMENT_SEND_CREATE_PREVIEW = '/invoicing/document/export/send/preview/create',
  INVOICING_DOCUMENT_EXPORT_HANDOVER = '/invoicing/document/export/handover',
  INVOICING_FISCALIZATION_CONFIGURATION = '/invoicing/fiscalization/configuration',
  INVOICING_DOCUMENT_EXPORT_FISCALIZATION_XML = '/invoicing/document/export/fiscalization-xml',

  PAYMENTS_LIST = '/invoicing/payment/payments',
  PAYMENT_PRINT = '/invoicing/payment/payment/print',
  PAYMENT_API_IMPORT = '/invoicing/payment/payments/api-import',
  PAYMENT_MANUAL_IMPORT = '/invoicing/payment/payments/manual-import',
  INVOICING_GET_AUTO_IMPORT_SETTINGS = '/invoicing/payment/payments/auto-import-settings',
  UNPAID_DOCUMENTS = '/invoicing/payment/unpaid-documents',
  PAYMENT_PRINT_SELECTED = '/invoicing/payment/payment/print/print-selected',
  PAYMENT_PRINT_IMPORTED = '/invoicing/payment/payment/print',
  INVOICING_PAYMENT_CREATE = '/invoicing/payment/payment',
  INVOICING_PAYMENT_DELETE = '/invoicing/payment/payment/:paymentId',
  INVOICING_PAYMENT_FISCALIZE_RESEND = '/invoicing/payment/payment/:paymentId/fiscalize/resend',

  OFFER_LIST = '/offer/offers',
  OFFER_DETAIL = '/offer/offer/:offerId',
  OFFER_CREATE = '/offer/offer',
  OFFER_UPDATE = '/offer/offer/:offerId',
  OFFER_CANCEL = '/offer/offer/:offerId/cancel',
  OFFER_SEND = '/offer/offer/:offerId/send',
  OFFER_SEND_PREVIEW = '/offer/offer/:offerId/send-preview',
  OFFER_SEND_REMINDER = '/offer/offer/:offerId/send-reminder',
  OFFER_PROCESSED_BY_FILTER_LIST = '/offer/filter/users',
  OFFER_OBJECT_KINDS = '/offer/offer/object-kinds',
  OFFER_HAS_NON_REF_PLAN = '/offer/offer/has-non-ref-plan',
  OFFER_GUEST_CATEGORIES = '/offer/offer/guest-categories',
  OFFER_DISCOUNT_SUGGESTIONS = '/offer/offer-discount/suggestions',
  OFFER_PRICE = '/offer/offer/variant-price',
  OFFER_SERVICE_LIST = '/offer/offer-service/online-services',
  OFFER_DEFAULT_MESSAGE = '/offer/offer/default-message',
  OFFERS_SETTINGS_GET = '/settings/applications/offers/settings',
  OFFERS_SETTINGS_UPDATE = '/settings/applications/offers/settings',

  REPORTS_DASHBOARD_GET_TILES_CONFIG = '/analytics/dashboard/tiles-config',
  REPORTS_DASHBOARD_SAVE_TILES = '/analytics/dashboard/tiles',
  REPORTS_DASHBOARD_GET_TILE_DATA = '/analytics/dashboard/tile-data',

  PROPERTY_FEE_PERFORMANCE_CURRENT = '/property/fee-performance/current',

  ALFRED_SETTINGS_SAVE = '/settings/applications/alfred/settings',
  ALFRED_SETTINGS_DETAIL = '/settings/applications/alfred/settings',
  ALFRED_PROPERTY_INFO = '/settings/applications/alfred/property-info/detail',
  ALFRED_REQUEST_ACTIVATION = '/settings/applications/alfred/request-activation',
  ALFRED_SETTINGS_TRIP_TIPS = '/settings/applications/alfred/trip-tips',
  ALFRED_SETTINGS_TRIP_TIP_CREATE = '/settings/applications/alfred/trip-tip',
  ALFRED_SETTINGS_TRIP_TIP_DETAIL = '/settings/applications/alfred/trip-tip/:tripTipId',
  ALFRED_SETTINGS_TRIP_TIP_UPDATE = '/settings/applications/alfred/trip-tip/:tripTipId',
  ALFRED_SETTINGS_TRIP_TIP_DELETE = '/settings/applications/alfred/trip-tip/:tripTipId',
  ALFRED_SETTINGS_TRIP_TIP_PHOTO_UPLOAD = '/settings/applications/alfred/trip-tip/photo',
  ALFRED_SETTINGS_TRIP_TIP_SETTINGS_DETAIL = '/settings/applications/alfred/settings/trip-tip-settings',
  ALFRED_SETTINGS_TRIP_TIP_SETTINGS_UPDATE = '/settings/applications/alfred/settings/trip-tip-settings',

  SETTINGS_GUEST_TAGS_LIST = '/settings/applications/guests-and-companies/guest-tags',
  SETTINGS_TAG_CREATE = '/settings/applications/guests-and-companies/tag',
  SETTINGS_TAG_UPDATE = '/settings/applications/guests-and-companies/tag/:tagId',
  SETTINGS_TAG_REMOVE = '/settings/applications/guests-and-companies/tag/:tagId',

  SETTINGS_COMPANY_TAGS_LIST = '/settings/applications/guests-and-companies/company-tags',
  SETTINGS_COMPANY_TAG_CREATE = '/settings/applications/guests-and-companies/company-tag',
  SETTINGS_COMPANY_TAG_UPDATE = '/settings/applications/guests-and-companies/company-tag/:tagId',
  SETTINGS_COMPANY_TAG_REMOVE = '/settings/applications/guests-and-companies/company-tag/:tagId',

  SETTINGS_LOCKSYSTEM_SETUP_LIST = '/settings/applications/lock-system/lock-systems-setup/list',
  SETTINGS_LOCKSYSTEM_SETUP_TEST = '/settings/applications/lock-system/lock-systems-setup/test-connection',
  SETTINGS_LOCKSYSTEM_SETUP_CREATE = '/settings/applications/lock-system/lock-systems-setup/create',
  SETTINGS_LOCKSYSTEM_SETUP_UPDATE = '/settings/applications/lock-system/lock-systems-setup/:lockSystemId/update',
  SETTINGS_LOCKSYSTEM_SETUP_DELETE = '/settings/applications/lock-system/lock-systems-setup/:lockSystemId/delete',
  SETTINGS_LOCKSYSTEM_SETUP_DOWNLOAD_LOCKS = '/settings/applications/lock-system/lock-systems-setup/:lockSystemId/download-locks',

  SETTINGS_LOCKSYSTEM_SETTINGS_LIST = '/settings/applications/lock-system/lock-systems-settings/list',
  SETTINGS_LOCKSYSTEM_SETTINGS_TEST = '/settings/applications/lock-system/lock-systems-settings/:lockSystemId/test-connection',
  SETTINGS_LOCKSYSTEM_SETTINGS_SETACTIVE = '/settings/applications/lock-system/lock-systems-settings/:lockSystemId/set-active',
  SETTINGS_LOCKSYSTEM_SETTINGS_REQUEST_CONNECTION = '/settings/applications/lock-system/lock-systems-settings/:lockVendorId/request-connection',
  SETTINGS_LOCKSYSTEM_SETTINGS_MAPPEDLOCKS_UPDATE = '/settings/applications/lock-system/lock-systems-settings/mapped-locks',
  SETTINGS_LOCKSYSTEM_SETTINGS_AUTOMATION_GET = '/settings/applications/lock-system/lock-systems-settings/lock-automation',
  SETTINGS_LOCKSYSTEM_SETTINGS_AUTOMATION_UPDATE = '/settings/applications/lock-system/lock-systems-settings/lock-automation',
  SETTINGS_LOCKSYSTEM_SETTINGS_AUTOMATION_RULES_GET = '/settings/applications/lock-system/lock-systems-settings/lock-automation-rules',
  SETTINGS_LOCKSYSTEM_SETTINGS_AUTOMATION_RULES_UPDATE = '/settings/applications/lock-system/lock-systems-settings/lock-automation-rules',

  GENERAL_SETTINGS_GET = '/settings/applications/guests-and-companies/general',
  GENERAL_SETTINGS_UPDATE = '/settings/applications/guests-and-companies/general',

  SETTINGS_ACCOUNTING_SOFTWARE_EXPORT = '/settings/applications/invoicing/export/accounting-software',
  SETTINGS_ACCOUNTING_SOFTWARE_EXPORT_UPDATE = '/settings/applications/invoicing/export/accounting-software',

  SETTINGS_ACCOUNTING_ROUNDING_DEFAULT = '/settings/applications/accounting/rounding/default',
  SETTINGS_ACCOUNTING_ROUNDING_EXCEPTION = '/settings/applications/accounting/rounding/exception',
  SETTINGS_ACCOUNTING_ROUNDING_EXCEPTIONS = '/settings/applications/accounting/roundings/exception',

  SETTINGS_ACCOUNTING_VAT_BREAKDOWN_CREATE = '/settings/applications/invoicing/export/vat-breakdown',
  SETTINGS_ACCOUNTING_VAT_BREAKDOWN_LIST = '/settings/applications/invoicing/export/vat-breakdown/list',
  SETTINGS_ACCOUNTING_VAT_BREAKDOWN = '/settings/applications/invoicing/export/vat-breakdown/:vatBreakdownId',
  SETTINGS_ACCOUNTING_VAT_BREAKDOWN_LINK_LIST = '/settings/applications/invoicing/export/vat-breakdown/link/list',
  SETTINGS_ACCOUNTING_VAT_BREAKDOWN_LINK = '/settings/applications/invoicing/export/vat-breakdown/link',

  SETTINGS_DOCUMENT_NUMBER_SERIES_LIST = '/settings/applications/invoicing/document/numberings/list',
  SETTINGS_DOCUMENT_NUMBER_SERIES_CREATE = '/settings/applications/invoicing/document/numbering',
  SETTINGS_DOCUMENT_NUMBER_SERIES = '/settings/applications/invoicing/document/numbering/:numberSeriesId',
  SETTINGS_DOCUMENT_NUMBER_SERIES_DEFAULT = '/settings/applications/invoicing/document/numbering/default',

  SETTINGS_GIFT_VOUCHER_NUMBER_SERIES_LIST = '/settings/applications/invoicing/gift-voucher/numberings/list',
  SETTINGS_GIFT_VOUCHER_NUMBER_SERIES_CREATE = '/settings/applications/invoicing/gift-voucher/numbering',
  SETTINGS_GIFT_VOUCHER_NUMBER_SERIES = '/settings/applications/invoicing/gift-voucher/numbering/:numberSeriesId',
  SETTINGS_GIFT_VOUCHER_NUMBER_SERIES_DEFAULT = '/settings/applications/invoicing/gift-voucher/numbering/default',

  SETTINGS_ACCEPTED_PAYMENT_TYPES = '/settings/applications/invoicing/accepted-payment-types',
  SETTINGS_REQUEST_NEW_PAYMENT_TYPE = '/settings/applications/invoicing/accepted-payment-types/request-new',

  SETTINGS_NUMBERING_PREVIEW = '/settings/applications/invoicing/numbering/preview',

  SETTINGS_PAYMENT_NUMBERING_LIST = '/settings/applications/invoicing/payment/numberings/list',
  SETTINGS_PAYMENT_NUMBERING_DETAIL = '/settings/applications/invoicing/payment/numbering/:numberingId',
  SETTINGS_PAYMENT_NUMBERING_UPDATE = '/settings/applications/invoicing/payment/numbering/:numberingId',
  SETTINGS_PAYMENT_NUMBERING_CREATE = '/settings/applications/invoicing/payment/numbering',
  SETTINGS_PAYMENT_NUMBERING_DELETE = '/settings/applications/invoicing/payment/numbering/:numberingId',

  SETTINGS_RESERVATION_GENERAL_GET = '/settings/applications/reservation/general-settings',
  SETTINGS_RESERVATION_GENERAL_UPDATE = '/settings/applications/reservation/general-settings',
  SETTINGS_RESERVATION_FOLIO_GET = '/settings/applications/reservation/folio-settings',
  SETTINGS_RESERVATION_FOLIO_UPDATE = '/settings/applications/reservation/folio-settings',
  SETTINGS_RESERVATION_VOUCHER_GET = '/settings/applications/reservation/voucher-settings',
  SETTINGS_RESERVATION_VOUCHER_UPDATE = '/settings/applications/reservation/voucher-settings',

  SETTINGS_HOTEL_EMAIL_GET = '/settings/hotel/email',
  SETTINGS_HOTEL_EMAIL_UPDATE = '/settings/hotel/email',
  SETTINGS_HOTEL_EMAIL_VALIDATE_SPF = '/settings/hotel/email/validate-spf',
  SETTINGS_HOTEL_EMAIL_TEST_CONNECTION = '/settings/hotel/email/test-connection',
  SETTINGS_HOTEL_EMAIL_AUTOCOMPLETE = '/settings/hotel/email/autocomplete',

  SETTINGS_HOTEL_WHATSAPP_GET = '/settings/hotel/whatsapp',
  SETTINGS_HOTEL_WHATSAPP_CONFIRM_CONSENT = '/settings/hotel/whatsapp/consent-confirmation',
  SETTINGS_HOTEL_WHATSAPP_CONNECT = '/settings/hotel/whatsapp/connect',
  SETTINGS_HOTEL_WHATSAPP_DISCONNECT = '/settings/hotel/whatsapp',

  SETTINGS_HOTEL_CURRENCY_LIST = '/settings/hotel/currency',
  SETTINGS_HOTEL_CURRENCY_CREATE = '/settings/hotel/currency',
  SETTINGS_HOTEL_CURRENCY_DEFAULT = '/settings/hotel/currency/default',
  SETTINGS_HOTEL_CURRENCY_UPDATE = '/settings/hotel/currency/:currencyId',
  SETTINGS_HOTEL_CURRENCY_DELETE = '/settings/hotel/currency/:currencyId',
  SETTINGS_HOTEL_CURRENCY_HISTORY = '/settings/hotel/currency/:currencyId/history',

  SETTINGS_DASHBOARD_GET = '/settings/dashboard',
  SETTINGS_DASHBOARD_ITEM_COMPLETE = '/settings/dashboard/items/:itemKey/mark-completed',
  SETTINGS_DASHBOARD_ITEM_INCOMPLETE = '/settings/dashboard/items/:itemKey/mark-incomplete',

  FEATURE_FLAG_INDEX = '/feature-flag/feature-flag/index',

  VERSION_SWITCH_FEEDBACK_SAVE = '/user/user/version-switch-feedback',
  VERSION_SWITCH_BACK = '/user/user/version-switch-back',

  AGENT_THREADS = '/agent/threads',

  AGENT_THREAD_DELETE = '/agent/threads/:threadId',

  AGENT_THREAD_RENAME = '/agent/threads/:threadId',

  AGENT_CHAT = '/agent/chat',

  AGENT_CHAT_MESSAGES = '/agent/chat/:threadId/messages',

  AI_TRANSLATE = '/ai/translate',
}
